export default {
  namespaced: true,
  vxg_camera: {
    id_vxg: "ID VXG",
    name: "Nome",
    rec_mode: "Modo Gravar",
    live_stream: "Transmissão ao Vivo",
    recording_stream: "Transmissão de Vídeo Gravado",
    access_token_watch: "Token de acesso ao vídeo",
    access_token_all: "Token de acesso total",
    streaming: "Transmissão",
    timezone: "Fuso horário",
    update_from_vxg: "Atualizar câmeras da API",
    select_multiple: "Selecione vários",
    delete_vxg_sbo: "Excluir VaaS e SBO",
    delete_sbo: "Excluir em SBO",
    removed: "Removido",
    removed_cameras: "câmeras removidas",
    rec_limit: "Dias de gravação",
    location: "Localização" || "Localizações",
    stream: "Transmissão",
    recording: "Gravação",
    main_transmission: "Transmissão de vídeo ao vivo",
    live_broadcast: "Transmissão de vídeo gravado",
    live_transmission: "Transmissão em vivo",
    transmission: "Configuração de transmissão",
    video_encoder: "Codificador de vídeo",
    vbr_quality: "Qualidade VBR",
    vbr: "VBR",
    events_enabled: "Eventos habilitados",
    register_type: "Tipo de Registro",
    bitrate: "Taxa de bits",
    update_stream: "Atualizar configuração de transmissão",
    ip: "IP",
    fps: "FPS de transmissão",
    resolution_stream: "Resolução de transmissão",
    format_stream: "Formato de transmissão",
    camera_not_connected: "A câmera não está conectada neste momento.",
  },
};
